// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

export enum TaskStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
}


export interface Task {
  id: string;
  providerCode: string;
  taskType: string | null;
  externalLoaId: string;
  brokerageName: string;
  brokerageLogoUrl: string | null;
  policyReferenceCode: string;
  policyTypeName: string;
  status: TaskStatus;
  slaDeadline: string | null;
  hasDocument: boolean;
  createdAt: string;
  updatedAt: string;
  metadata: TaskMetadata | null;
}

export interface TaskMetadata {
  brokerage?: {
    name?: string;
    subdomain?: string;
    logoUrl?: string;
    registrationNumber?: string;
    contactEmail?: string;
    contactPhone?: string;
    address?: TaskAddress;
  };
  advisor?: {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    licenseNumber?: string;
  };
  policy?: {
    referenceCode?: string;
    policyNumber?: string;
    policyTypeName?: string;
    policyTypeCategory?: string;
  };
  profile?: {
    name?: string;
  };
  signatories?: TaskSignatory[];
  document?: {
    ref?: string;
    checksum?: string;
    sizeBytes?: number;
    contentType?: string;
  };
  completedAt?: string;
  totalSignatories?: number;
  isFirstLoaForPolicy?: boolean;
}

export interface TaskSignatory {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  dateOfBirth?: string;
  address?: TaskAddress;
  relationshipType?: string;
  signedAt?: string;
  hasOverrides?: boolean;
  overrideReason?: string;
}

export interface TaskAddress {
  line1?: string;
  line2?: string;
  townCity?: string;
  stateProvinceCounty?: string;
  postalCode?: string;
  country?: string;
  countryCode?: string;
}

export interface TaskSummary {
  pending: number;
  inProgress: number;
  completed: number;
  rejected: number;
  cancelled: number;
  total: number;
}

export interface ProviderConfig {
  providerCode: string;
  providerName: string;
  displayName: string;
  logoUrl: string | null;
  portalEnabled: boolean;
  slaHours: number;
}

export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}
